import { EditFooterBrandInfo } from './editFooterBrandInfo';
import { EditFooterColumn } from './editFooterColumn';
import { EditFooterContactUs } from './editFooterContactUs';
import { EditFooterCopyright } from './editFooterCopyright';
import { EditFooterSocialLinks } from './editFooterSocialLinks';
import './styles.scss';
import { Col, Row, Button } from 'antd';

export default function EditWebsiteFooter() {
  return (
    <div className="edit-footer">
      <div className="content">
        <Row gutter={12}>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <div className="card">
              <div className="heading">
                <p className="label">Column 1</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="list">
                <div className="group">
                  <p className="title">Group Title 1</p>
                  <div className="list">
                    <div className="item">
                      <p className="link">Group link 1</p>
                    </div>
                    <div className="item">
                      <p className="link">Group link 2</p>
                    </div>
                  </div>
                </div>
                <div className="group">
                  <p className="title">Group Title 1</p>
                  <div className="list">
                    <div className="item">
                      <p className="link">Group link 1</p>
                    </div>
                    <div className="item">
                      <p className="link">Group link 2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="heading">
                <p className="label">Column 2</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="list">
                <div className="group">
                  <p className="title">Group Title 1</p>
                  <div className="list">
                    <div className="item">
                      <p className="link">Group link 1</p>
                    </div>
                    <div className="item">
                      <p className="link">Group link 2</p>
                    </div>
                  </div>
                </div>
                <div className="group">
                  <p className="title">Group Title 1</p>
                  <div className="list">
                    <div className="item">
                      <p className="link">Group link 1</p>
                    </div>
                    <div className="item">
                      <p className="link">Group link 2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="heading">
                <p className="label">Column 3</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="list">
                <div className="group">
                  <p className="title">Group Title 1</p>
                  <div className="list">
                    <div className="item">
                      <p className="link">Group link 1</p>
                    </div>
                    <div className="item">
                      <p className="link">Group link 2</p>
                    </div>
                  </div>
                </div>
                <div className="group">
                  <p className="title">Group Title 1</p>
                  <div className="list">
                    <div className="item">
                      <p className="link">Group link 1</p>
                    </div>
                    <div className="item">
                      <p className="link">Group link 2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <EditFooterColumn />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="card">
              <div className="heading">
                <p className="label">Brand Information</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="item">
                  <p className="label">Logo: </p>
                  <div className="image">
                    <img src="https://logos-world.net/wp-content/uploads/2020/04/Huawei-Logo-700x394.png" />
                  </div>
                </div>
                <div className="item">
                  <p className="label">About Company: </p>
                  <p className="value">
                    Far far away, behind the word mountains, far from the
                    countries Vokalia and Consonantia, there live the blind
                    texts.Far far away, behind the word mountains, far from the
                    countries Vokalia and Consonantia, there live the blind
                    texts.
                  </p>
                </div>
              </div>
            </div>
            <EditFooterBrandInfo />
            <div className="card">
              <div className="heading">
                <p className="label">Contact Us</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="item">
                  <span className="label">Phone: </span>
                  <span className="value">+91-9876543210</span>
                </div>
                <div className="item">
                  <p className="label">Address:</p>
                  <p className="value">
                    Far far away, behind the word mountains
                  </p>
                </div>
                <div className="item">
                  <span className="label">Email: </span>
                  <span className="value">admin@admin.com</span>
                </div>
              </div>
            </div>
            <EditFooterContactUs />
            <div className="card">
              <div className="heading">
                <p className="label">Social Links</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="item">
                  <p className="label">Facebook: </p>
                  <p className="value">
                    https://dental-website-psi.vercel.app/
                  </p>
                </div>
                <div className="item">
                  <p className="label">Twitter: </p>
                  <p className="value">
                    https://dental-website-psi.vercel.app/
                  </p>
                </div>
                <div className="item">
                  <p className="label">Instagram: </p>
                  <p className="value">
                    https://dental-website-psi.vercel.app/
                  </p>
                </div>
                <div className="item">
                  <p className="label">Youtube: </p>
                  <p className="value">
                    https://dental-website-psi.vercel.app/
                  </p>
                </div>
              </div>
            </div>
            <EditFooterSocialLinks />
            <div className="card">
              <div className="heading">
                <p className="label">Copyright</p>
                <div className="actions">
                  <Button type="primary">Edit</Button>
                </div>
              </div>
              <div className="content">
                <div className="item">
                  <p className="label">Copyright:</p>
                  <p className="value">© Laxaar | All Rights Reserved</p>
                </div>
              </div>
            </div>
            <EditFooterCopyright />
          </Col>
        </Row>
      </div>
    </div>
  );
}
